import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { setToken, userExternalSignIn } from '../appRedux/actions';
import CircularProgress from '../components/CircularProgress';
// import { Container } from './styles';

function ExternalAuth() {
  const location = useLocation();
  const values = queryString.parse(location.search)
  const history = useHistory();
  var dispatch = useDispatch();
  const link = useRef(null);
  const [reserveToken, setReserveToken] = useState(false);
  useEffect(() => {
    if (values?.token) 
    {
      localStorage.setItem("token", values.token);
      dispatch(setToken(values.token));
    } else {
      if (reserveToken == false) {
        if (link.current.href != "") {
          return;
        }
        link.current.href = `https://getway.agahinaslefarda.ir/Login/ExternalLogin?ver_code=${values.ver_code}&office=${values.office}&nc=${values.nc}`;
        link.current.click();
        // dispatch(userExternalSignIn(values));
        setReserveToken(true);
      }
    }
  }, [values]);

  const {
    loader,
    token,
    callBackUrl,
    alertMessage,
    showMessage,
  } = useSelector(({ auth }) => {
    return auth;
  });

  useEffect(() => {
    if (token != null) {
      history.push("/samplePage");
    }
  });

  // useEffect(() => {
  //   if (callBackUrl != null) {
  //     if (link.current.href != "") {
  //       return;
  //     }
  //     link.current.href = callBackUrl;
  //     link.current.click();
  //   }
  // }, [callBackUrl]);

  return (
    <div>
      <a ref={link}></a>
      {loader ? (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      ) : null}
    </div>
  );
}

export default ExternalAuth;